module.exports = __webpack_public_path__ + "img/rtt_rtdgametoken.5c32b88.png";